module.exports = __webpack_public_path__ + "img/icon-question.e595934a.svg";